import Vue from 'vue';
import VueRouter from 'vue-router';
import Store from '@/store';
import Routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes: Routes,
});

// This app is being phased out and will only serve the exam-taking flow.
// On that domain, any route outside of that flow bounces to the Auth app,
// same as clicking "Iniciar sesión" in Login.vue.
const EXAMS_ONLY_HOST = process.env.VUE_APP_EXAMS_HOST;
const EXAMS_ONLY_ALLOWED_ROUTES = ['Auth', 'examStarted', 'error'];

/* eslint-disable-next-line */
router.beforeEach(async (to, from, next) => {
  if (from.name === 'maintenance') return null;

  // eslint-disable-next-line no-console

  if (EXAMS_ONLY_HOST && window.location.origin === EXAMS_ONLY_HOST) {
    if(!EXAMS_ONLY_ALLOWED_ROUTES.includes(to.name)){
      return next({
        name: 'error',
        params: {
          errorCode: 404,
        }
      });
    }
    // eslint-disable-next-line no-console
    Store.dispatch('AuthFirebase/authRedirectExams', { route: { query: { redir: to.path } }, action: 'authorize' });
    return next(false);
  }

  if(to.name === 'Auth') return next();

  try {
    const isAuthenticated = await Store.dispatch('Auth/isAuthenticated');
    const exam = Store.state.Auth.exam;

    if (from.query.redir && !from.query.redir.startsWith('/')) {
      from.query.redir = `/${from.query.redir}`;
    }

    if (isAuthenticated && !exam && from.path === '/legacy-login' && from.query.redir && to.path !== from.query.redir){
      if(from.query.redir === 'dashboard') return next()

      return next(from.query.redir)
    }

    // If not authenticated and the route require authentication, redirected to the login with the query parameters (if any)
    if (!isAuthenticated && to.meta.requiresAuth) {
      const path = to.path;
      const query = path !== '/logout' ? { redir: path } : {};
      return next({ name: 'Login', query });
    }

    if (to.meta.history) Store.dispatch('services/api/router/history/add', { from, to, next });

    // If the user is taking an exam, force redirect to the exam screen
    if (exam !== null && to.name !== 'examStarted') {
      return next({
        name: 'examStarted',
        params: {
          courseCode: exam.course_code,
          calendarId: exam.calendar_id,
          exam: exam.exam
        }
      });
    }

    const isLoginPath = to.path === '/login' || to.path === '/legacy-login';

    // If the user is authenticated and manually wants to go to /login, redirect to courses
    if(isAuthenticated && isLoginPath){
      return next({name: 'courses'})
    }

    if(isAuthenticated && to.query.redir && from.fullPath !== to.query.redir){
      return next(to.query.redir);
    }

    /* Cases
    - Unauthenticated user and towards a route that does not require authentication
    - Authenticated user, on a route wanting to go to another route different from login
     */
    return next();
  } catch (error) {
    console.error(error);
  }
});

export default router;
